import React from 'react';
import { Box, Divider, Grid } from '@material-ui/core';
import { sizes } from 'src/styles/Media.styled';
import { Title } from '../Procedure.styled';
import { SubTitle } from './PhysicianFinder.styled';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import i18n from 'src/i18n.js';
import {
    FONT_FAMILY_REGULAR,
    BLACK_FONT_COLOR,
    SEMANTIC_TEXT_PX
} from 'src/styles/fonts/MCFontConstants';

const t = (key) => i18n.t(key);

const PhysicianFinderCard = ({
    physicianFinderData,
    checkboxSelectionChangeHandler,
    physicianFinderTitle = t(
        'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.physicianFinder.title'
    ),
}) => {
    const winWidth = window.innerWidth;
    const isMobileView = winWidth < sizes.smalDevice;
    const lastPhysicianFinderData =
        physicianFinderData[physicianFinderData.length - 1];
    return (
        <Box
            my={1}
            bgcolor={'#ffffff'}
            boxShadow={'0px 0px 6px #00000029'}
            borderRadius={5}
            // padding={'16px 22px'}
            width={'99.66%'}
            position={'relative'}
            border={
                physicianFinderData.filter((item) => item.isSelected).length > 0
                    ? '1px solid #12C8F7'
                    : ''
            }
            marginLeft={'1px'}
            marginRight={'1px'}
        >
            <Title
                paddingTop={'16px'}
                paddingRight={'22px'}
                paddingLeft={'22px'}
                mbpaddingTop={'16px'}
                mbpaddingRight={'22px'}
                mbpaddingLeft={'22px'}
            >
                <span>{physicianFinderTitle}</span>
                <span className="asterisk">*</span>
            </Title>
            <SubTitle padding={'0 22px 5px 22px'}>
                {t(
                    'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.physicianFinder.pleaseCheckMsg'
                )}
            </SubTitle>
            <Grid container>
                {isMobileView && (
                    <Grid item xs={12} style={{ paddingBottom: '12px' }}>
                        <Divider />
                    </Grid>
                )}

                {physicianFinderData &&
                    physicianFinderData.map((obj, idx) => (
                        <Grid
                            item
                            xs={isMobileView ? 12 : 6}
                            key={obj.code}
                            style={{
                                height:
                                    obj !== lastPhysicianFinderData
                                        ? '50px'
                                        : '40px',
                            }}
                        >
                            <Checkbox
                                id={obj.description}
                                checked={obj.isSelected}
                                label={obj.description}
                                margin={'3px 0 0 22px'}
                                labelStyleObj={{
                                    fontFamily: FONT_FAMILY_REGULAR,
                                    textAlign: 'left',
                                    fontSize: SEMANTIC_TEXT_PX,
                                    letterSpacing: '-0.12px',
                                    color: BLACK_FONT_COLOR,
                                    opacity: 1,
                                    paddingLeft: '17px',
                                }}
                                onCheckboxSelectionChange={(e) =>
                                    checkboxSelectionChangeHandler(
                                        e,
                                        'physicianFinder',
                                        idx,
                                        obj.description
                                    )
                                }
                            />

                            {isMobileView && (
                                <Grid
                                    item
                                    xs={12}
                                    style={{
                                        paddingBottom: '12px',
                                        paddingTop: '12px',
                                    }}
                                >
                                    {obj !== lastPhysicianFinderData && (
                                        <Divider />
                                    )}
                                    {/* <Divider /> */}
                                </Grid>
                            )}
                        </Grid>
                    ))}
            </Grid>
        </Box>
    );
};

export default PhysicianFinderCard;
